import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

// Routes a blocked user may still view. Everything else is redirected to
// /reconsent. The backend reconsentGate middleware is the defense-in-depth
// twin of this UX gate.
const ALLOW = [/^\/reconsent/, /^\/legal/, /^\/account\/close/, /^\/login/];

export function ReconsentGate() {
  const { user, impersonation } = useAuth();
  const { pathname } = useLocation();
  const blocked = user?.legal_consent?.blocked;
  // Staff viewing as the person cannot accept for them, so they are not sent
  // to /reconsent; the backend gate exempts the session the same way.
  if (blocked && !impersonation && !ALLOW.some((re) => re.test(pathname))) {
    return <Navigate to="/reconsent" replace />;
  }
  return <Outlet />;
}
